export default class CheckUserExists {
	constructor(
		url,
		resultWrapper,
		nameField,
		surnameField,
		birthdateField,
		birthplaceField,
		currentUuid,
	) {
		this.url = url;
		this.resultWrapper = resultWrapper;
		this.nameField = nameField;
		this.surnameField = surnameField;
		this.birthdateField = birthdateField;
		this.birthplaceField = birthplaceField;
		this.currentUuid = currentUuid;

		const filtered = [
			nameField,
			surnameField,
			birthdateField,
			birthplaceField,
		].filter((field) => !!field);
		for (const field of filtered) {
			field.addEventListener("change", () => this.change());
		}
	}

	async change() {
		this.resultWrapper.innerHTML = "";

		const name = this.nameField.value;
		const surname = this.surnameField.value;
		const birthdate = this.birthdateField.value;
		const birthplace = this.birthplaceField ? this.birthplaceField.value : "";
		const url = this.url;

		if (
			!name ||
			!surname ||
			!birthdate ||
			(this.birthplaceField && !birthplace)
		) {
			return;
		}

		const formData = new FormData();
		formData.append("name", name);
		formData.append("surname", surname);
		formData.append("birthdate", birthdate);
		formData.append("birthplace", birthplace);
		formData.append("currentUuid", this.currentUuid);

		const response = await fetch(url, {
			method: "post",
			body: formData,
		});

		if (response.status !== 200) {
			return;
		}

		const result = await response.json();

		if (result.url) {
			this.resultWrapper.innerHTML = `
        <div class="bs-callout bs-callout-danger">
          <h4>Benutzer existiert bereits</h4>
          <p>Ein Benutzer mit diesen Daten wurden bereits gefunden:</p>
          <p><a href="${result.url}" class="btn btn-default">Benutzer aufrufen</a></p>
        </div>
      `;
		}
	}
}
